import React, { useMemo, useReducer } from 'react';
import { loginReducer } from './loginReducer';
import { LoginContext } from './useLogin';

type LoginProviderProps = {
  children: React.ReactNode;
};

export const LoginProvider = (props: LoginProviderProps) => {
  const [state, dispatch] = useReducer(loginReducer, {
    data: { type: 'REQUESTING_OTP', phoneNumber: '' },
    loading: false,
  });
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <LoginContext.Provider
      value={{ state: contextValue.state, dispatch: contextValue.dispatch }}
    >
      {props.children}
    </LoginContext.Provider>
  );
};
